// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9aYpk","title":"_61ZaJ"};